<template>
	<div class="selectGift">
		<el-dialog title="选择产品" :visible.sync="dialogTableVisible">

			<el-tabs class="tabs" v-model="activeName" type="product" @tab-click="tableChange">
				<el-tab-pane label="产品" name="product"></el-tab-pane>
				<el-tab-pane label="耗材" name="consume"></el-tab-pane>
			</el-tabs>

			<div v-if="activeName == 'product'">
				<div>
					<div class="overFix">
						<span>产品分类：</span>
						<el-radio-group
							v-model="productType"
							class="radios"
							@change="radioChange"
						>
							<!-- <el-radio label="">全部产品</el-radio> -->
							<el-radio
								v-for="(item, index) in options"
								:key="index"
								:label="index"
								>{{ item.name }}</el-radio
							>
						</el-radio-group>
					</div>
				</div>
				<el-table
					ref="multipleProTable"
					:data="list"
					max-height="500px"
					@select-all="selectAll"
					@select="select"
					header-cell-class-name="table_header_bgcolor"
				>
					<el-table-column
						prop="productName"
						label="商品名称"
						width="auto"
					></el-table-column>
					<el-table-column type="selection" width="55"> </el-table-column>
				</el-table>
			</div>
			<div v-else>
				<div>
					<div class="overFix">
						<span>耗材分类：</span>
						<el-radio-group
							v-model="consumeType"
							class="radios"
							@change="consumeRadioChange"
						>
							<!-- <el-radio label="">全部产品</el-radio> -->
							<el-radio
								v-for="(item, index) in consumeOptions"
								:key="index"
								:label="index"
								>{{ item.name }}</el-radio
							>
						</el-radio-group>
					</div>
				</div>
				<el-table
					ref="multipleProTable"
					:data="consumeList"
					max-height="500px"
					@select-all="consumeSelectAll"
					@select="consumeSelect"
					header-cell-class-name="table_header_bgcolor"
				>
					<el-table-column
						prop="productName"
						label="商品名称"
						width="auto"
					></el-table-column>
					<el-table-column type="selection" width="55"> </el-table-column>
				</el-table>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="calcel">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
export default {
	data() {
		return {
			dialogTableVisible: false,
			activeName: "product",
			deleteRow: {},

			selectList: [],
			options: [],
			list: [],
			productType: 0,

			selectConsumeList: [],
			consumeOptions: [],
			consumeList: [],
			consumeType: 0,
		}
	},
	mixins: [minxin],
	components: {},
	created() {
		this.init()
	},
	mounted() {
		//this.getTableArr();
	},
	watch: {
		list() {
			for (let i in this.list) {
				let isExist = false;
				if (this.selectList != undefined) {
				for (let j in this.selectList) {
					if (this.selectList[j].id == this.list[i].id) {
						isExist = true;
						break;
					}
				}
				}
				if (isExist) {
				this.$nextTick(function() {
					this.$refs.multipleProTable.toggleRowSelection(this.list[i], true);
				});
				}
			}
		},
		consumeList() {
			for (let i in this.consumeList) {
				let isExist = false;
				if (this.selectConsumeList != undefined) {
				for (let j in this.selectConsumeList) {
					if (this.selectConsumeList[j].id == this.consumeList[i].id) {
					isExist = true;
					break;
					}
				}
				}
				if (isExist) {
				this.$nextTick(function() {
					this.$refs.multipleProTable.toggleRowSelection(this.consumeList[i], true);
				});
				}
			}
		}
	},
	methods: {
		init() {
			this.$on('set', function(org) {
				console.log('org: ', JSON.parse(JSON.stringify(org)))
				this.dialogTableVisible = true
				// this.selectList = JSON.parse(JSON.stringify(org));

				let dic = JSON.parse(JSON.stringify(org));
				this.selectList = dic.selectList;
				this.selectConsumeList = dic.selectConsumeList;
				// let arr = [];
				// arr.concat(org.selectList);
				// arr.concat(org.selectConsumeList);

				this.getCategroy()
			})
		},
		getCategroy() {
			this.options = [];
			this.list = [];
			this.$api.post(this.$url.inventoryProduct.productListByShopId).then((res) => {
				if (res) {
					let arr = [];
					res.map(item => {
						if (item.itemList) {
							arr = arr.concat(item.itemList);
						}
					})
					let obj = {id: '', name: '全部产品', itemList: arr };
					this.options.push(obj);
					this.options = this.options.concat(res);
					this.list = this.options[0].itemList;

					this.radioChange(this.productType);
				}
			})
		},
		getConsume() {
			this.$api.post(this.$url.inventoryProduct.consumableListByShopId).then((res) => {
				if (res) {
					let arr = [];
					res.map(item => {
						if (item.itemList) {
							arr = arr.concat(item.itemList);
						}
					})
					let obj = {id: '', name: '全部耗材', itemList: arr };
					this.consumeOptions = res; 
					this.consumeOptions.unshift(obj);
					this.consumeList = this.consumeOptions[0].itemList;

					this.consumeRadioChange(this.consumeType);
				}
			})
		},
		tableChange(val) {
			this.activeName = val.name;
			if (this.activeName == 'product') {
				// if (this.options.length == 0) {
				// 	this.getCategroy();	
				// }
				this.getCategroy();	
				// this.productType = 0;
			}else {
				// if (this.consumeOptions.length == 0) {
				// 	this.getConsume();	
				// }
				this.getConsume();	
				// this.consumeType = 0;
			}
		},
		radioChange(value) {
			console.log("value: ", value);
			// this.selectList = []
			// this.$refs.multipleProTable.clearSelection()
			this.list = this.options[value].itemList;
		},
		consumeRadioChange(value) {
			console.log("value: ", value);
			// this.selectList = []
			// this.$refs.multipleProTable.clearSelection()
			this.consumeList = this.consumeOptions[value].itemList;
		},

		selectAll (selection) {
			if (selection.length > 0) {
				this.selectList = selection;
			} else {
				this.selectList = [];
			}
		},

		consumeSelectAll (selection) {
			if (selection.length > 0) {
				this.selectConsumeList = selection;
			} else {
				this.selectConsumeList = [];
			}
		},

		select(selection, row) {
			if (selection.length) {
				this.selectList = selection;
			}
		},
		consumeSelect(selection, row) {
			if (selection.length) {
				this.selectConsumeList = selection;
			}
		},

		calcel() {
			this.selectList = []
			this.selectConsumeList = []
			this.productType = 0
			this.activeName = 'product'
			this.dialogTableVisible = false
		},

		confirm() {
			if (this.selectList.length == 0 && this.selectConsumeList.length == 0) {
				return this.$message.error('请勾选至少一个商品')
			}
			let obj = {};
			this.selectList = this.selectList.reduce((cur, next) => {
				obj[next.id] ? "" : (obj[next.id] = true && cur.push(next));
				return cur;
			}, []); //设置cur默认类型为数组，并且初始值为空的数组

			let consumeObj = {};
			this.selectConsumeList = this.selectConsumeList.reduce((cur, next) => {
				consumeObj[next.id] ? "" : (consumeObj[next.id] = true && cur.push(next));
				return cur;
			}, []); //设置cur默认类型为数组，并且初始值为空的数组

			this.$emit('changeGift', {'selectList':this.selectList,'selectConsumeList':this.selectConsumeList})
			this.selectList = []
			this.selectConsumeList = []
			this.productType = 0
			this.activeName = 'product'
			this.dialogTableVisible = false
		},
	},
}
</script>

<style lang="less" scoped>
.overFix {
	padding: 10px 5px;
}
.selectGift {
	/deep/ .el-dialog__header {
		padding: 10px;
	}
	/deep/ .el-dialog__body {
		padding: 0 10px;
	}
}
</style>
